import React from 'react';
import { useTranslations } from '@lang';
import { useRoomSettings } from '@features/roomSettings';
import styled from 'styled-components';

const RoomCapacityWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
`;
export default function useRoomCapacityText({ maxAdults, maxChildren, maxOccupancy }) {
  const { t } = useTranslations();
  const { data: roomSettings } = useRoomSettings();
  const { adultOnlyBookings } = roomSettings?.data || {};
  const showCapacity = maxAdults !== null;

  if (showCapacity && adultOnlyBookings) {
    return t('room.roomCapacityAdultsOnly', { maxAdults });
  }
  if (showCapacity && !adultOnlyBookings) {
    return (
      <RoomCapacityWrapper>
        <p>{t('room.roomSleeps', { maxOccupancy })}</p>
        <p>{t('room.roomCapacity', { maxOccupancy, maxAdults, maxChildren })}</p>
      </RoomCapacityWrapper>
    );
  }
  if (!showCapacity) {
    return t('room.roomSleeps', { maxOccupancy });
  }

  return '';
}
